import {
    BRAND_CREATE,
    BRAND_FETCH,
    BRAND_UPDATE,
    BRAND_FETCH_PROMO,
    BRAND_UPDATE_PROMO
} from '../actions/types';

const INITIAL_STATE = { 
    brands: null,
    loading: false,
    promoBrand: []
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
        case BRAND_CREATE:
        case BRAND_UPDATE:
        case BRAND_UPDATE_PROMO:
            return { ...state, loading: action.payload }
        case BRAND_FETCH:
            return { ...state, brands: action.payload }
        case BRAND_FETCH_PROMO:
            return { ...state, promoBrand: action.payload }
        default:
            return state
    }
}